// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projectConfig[data-v-7dd080bd] {\n  width: 100%;\n  height: 100%;\n  background: #eef6fa;\n  margin-top: 3.125rem;\n}\n.config-body[data-v-7dd080bd] {\n  height: 92%;\n  padding: 1.875rem 3.125rem;\n  overflow: hidden;\n}\n.center-box[data-v-7dd080bd] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 18.75rem;\n}\n.full-box[data-v-7dd080bd] {\n  width: 100%;\n  height: 90%;\n}\n.tip-box[data-v-7dd080bd] {\n  color: #fc7790;\n}", ""]);
// Exports
module.exports = exports;
